import React from "react";
//import Input from "semantic-ui-react/dist/commonjs/elements/Input";
import { Dropdown, Input } from 'semantic-ui-react'

const toInt = (value) => {
  if(typeof value === "string") {
    return parseInt(value, 10);
  } else {
    return value;
  }
}

export class SearchKeyword extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getState(props);
  }
  componentWillReceiveProps(newProps) {
    this.setState(this.getState(newProps));
  }
  getState(props) {
    return { value: Object.assign({}, props.value) };
  }
  onUpdateValue(value) {
    let newValue = Object.assign({}, this.state.value);
    for (const key in value) {
      if (value[key]) {
        newValue[key] = value[key];
      } else {
        if (key == "keywordTarget") {
          newValue = { keywordTarget: 0 }
          continue;
        }
        delete newValue[key];
      }
    }
    this.setState({ value: newValue });
  }
  onSearch = () => {
    this.props.onSearch(this.state.value);
  };
  onKeyDown = e => {
    if (e.keyCode === 13) {
      this.onSearch();
    }
  };
  render() {
    /* masterDataに入れると物件リストまで引っ張ってきちゃうのでここで定義 */
    const options = [
      { key: 0, text: 'すべて', value: 0 },
      { key: 1, text: '住所'  , value: 1 },
      { key: 2, text: '駅名'  , value: 2 },
      { key: 3, text: '物件名', value: 3 },
    ]
    return (
      <div className="searach_keyword">
        <Input
          type="text"
          style={{width:"100%"}}
          placeholder="例）渋谷　"
          value={this.state.value && this.state.value.keyword || ""}
          onChange={(event, element) => {
            this.onUpdateValue({ keyword: element.value });
          }}
          onKeyDown={this.onKeyDown}
          label={<Dropdown
            value={toInt(this.state.value.keywordTarget)}
            defaultValue={0}
            style={{width:"100px"}}
            //key="0"
            options={options}
            onChange={(event, element) => {
              this.onUpdateValue({ keywordTarget: element.value });
            }}
            className="dropdown_onlysp"
          />}
          labelPosition='left'
        >
        </Input>
        <div className="btn" onClick={this.onSearch}>
          キーワード検索
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/SearchKeyword.jsx